import { PNEX_MODULE } from "./cr.ext.pnex";
import { TWAR_MODULE } from "./cr.ext.twar"
import { VanillaListPlayedMatches, VanillaListPlayers, VanillaPlayerTitle, vanillaAdminRewards } from "./cr.ext.vanilla";
import { useExt } from "./ext"
import { usePlayer } from "./player";
import { CRUSADE_RELICS_TWAR } from "./unit.relics.twar";
import { BATTLE_TRAITS_TWAR } from "./unit.traits.twar";

export const EXT_NAMES = {
    'VANILLA': 'Vanilla',
    'TWAR': 'Tyranic War',
    'PNEX': 'Pariah Nexus',
}

export const EXT_MODULES = {
    'VANILLA': {
        playerCheck: () => true,
        playerCheckModule: () => <></>,
        playerCrusadeTop: () => <></>,
        playerList: () => <VanillaListPlayers />,
        playerTitle: () => <VanillaPlayerTitle />,
        playerDetailIcon: () => <></>,

        matchesListPlayed: (matches) => <VanillaListPlayedMatches matches={matches} />,

        unitSections: () => <></>,
        unitStats: () => <></>,
        unitUpgrades: () => <></>,
        customTraits: () => <></>,
        battleTraitCall: (id) => { return "unit/" + id + "/trait/new" },
        customRelics: () => <></>,
        relicsCall: (id) => { return "unit/" + id + "/relic/new" },

        reportAfterKills: () => <></>,
        docs: ['doc-crusade-core'],

        adminRewards: vanillaAdminRewards,

        matchCall: (crusadeId, matchId) => 'match/' + crusadeId + '-' + matchId + '/report/submit',
        relics: CRUSADE_RELICS_TWAR, // purtroppo non esistono vanilla..
        traits: BATTLE_TRAITS_TWAR, // purtroppo non esistono vanilla..

    },
    'TWAR': TWAR_MODULE,
    'PNEX': PNEX_MODULE,
}

export function CExtPlayerCrusadeTop() {
    const ext = useExt();
    const player = usePlayer();

    return ext.playerCrusadeTop(player, ext);
}

export function CExtPlayerList() {
    const ext = useExt();

    return ext.playerList()
}